import React from "react";
import "./FilterBar.scss";

/**
 * FilterBar — Horizontal strip of filter chips / select controls.
 *
 * Props:
 *   children  — filter elements (selects, chips, etc.)
 *   actions   — right-side action buttons (ReactNode)
 *   className — extra class
 */
const FilterBar = ({ children, actions, className = "" }) => (
  <div className={`filter-bar ${className}`}>
    <div className="filter-bar__filters">{children}</div>
    {actions && <div className="filter-bar__actions">{actions}</div>}
  </div>
);

/**
 * FilterSelect — Small themed select dropdown for FilterBar.
 */
const FilterSelect = ({ label, value, onChange, options = [], className = "" }) => (
  <div className={`filter-select ${className}`}>
    {label && <label className="filter-select__label">{label}</label>}
    <select
      className="filter-select__control"
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  </div>
);

export { FilterBar, FilterSelect };
export default FilterBar;
